import {select} from "../../store";
import {createRouteGuard} from "../../routers/createRouteGuard";

export const AdminHasReportingAccess = createRouteGuard({
  authenticatedSelector: select.adminSession.hasReportingAccess,
  redirectPath: "/admin/dashboard",
});
